import React from "react";
import windowsI from '../../images/home/windows-app.png';

function WindowsApplication() {
  return (
    <>

      <Hero />
      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={windowsI}
                alt="Windows Application"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Desktop Applications For Specific Business Needs</h2>

                <p>
                  Some business processes are better handled through a
                  dedicated desktop application. We develop focused Windows
                  applications for clients who need reliable desktop tools.
                </p>

                <p>
                  These applications can work with local or centralized
                  databases and can be designed around your existing workflow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Features />
      <CTA />
    </>
  );
}

function Hero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">

          <h1>Windows Applications</h1>
          <p style={{ color: '#FF7D37' }}>
            Focused desktop applications built to solve specific business
            requirements.
          </p>
        </div>
      </div>
    </section>
  );
}

function Features() {
  return (
    <section className="service-features-section">
      <div className="container">
        <div className="section-heading text-center">

          <h2>Built Around Your Workflow</h2>
        </div>

        <div className="row g-4">
          {[
            ["Business Tools", "Small applications for specific business tasks and workflows."],
            ["Database Connectivity", "Connect your application with required business databases."],
            ["Easy To Use", "Simple interfaces designed for practical day-to-day use."]
          ].map(([title, text]) => (
            <div className="col-lg-4 col-md-6" key={title}>
              <div className="service-feature-card">
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>DESKTOP SOLUTIONS</span>
            <h2>Need A Custom Windows App?</h2>
            <p>Let's discuss your application requirements.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default WindowsApplication;